export default "__VITE_ASSET__BcNRi7wj__"